<!--
 * @Date: 2022-09-28 17:36:33
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-13 12:33:01
 * @description: description
-->
<template>
  <div :class="$style.aboutusBanner">
    <div :class="$style.headBox">
      <div :class="$style.headBgRight" />
      <div :class="$style.bannerTitle">{{ info.title }}</div>
      <div :class="$style.bannerTitleEn">{{ info.titleEn }}</div>
      <div :class="$style.headBg" />
      <div :class="$style.bannerContentBox">
        <div :class="$style.bannerContentInfo">
          <p
            :class="$style.contentItem"
            :key="index"
            v-for="(item, index) in info.content"
          >
            {{ item }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  props: {
    info: Object
  }
}
</script>
<style lang="scss" module>
.aboutusBanner {
  position: relative;

  // background-image: url("../../../assets/img/aboutus/pc/sense.of.worth/left-icon.png"),
  //   url("../../../assets/img/aboutus/pc/sense.of.worth/value-bg.png"),
  //   url("../../../assets/img/aboutus/pc/sense.of.worth/right-icon.png");
  // background-repeat: no-repeat;
  // background-position: left top 6px, left 30px top, right bottom 20px;
  // background-size: 30px 25px, 214px 188px, 30px 25px;

  .headBox {
    box-sizing: border-box;
    position: relative;
    width: 100%;
    // height: 895px;
    padding-top: 40px;
    text-align: center;
    background: linear-gradient(180deg, #fff0d7 0%, #fffcf7 100%), #ffffff;
    background-size: 100% 400px, 100% 800px;
    background-repeat: no-repeat;
  }

  .headBgRight {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    width: 99px;
    height: 180px;
    background: linear-gradient(180deg, #ffb393 0%, #fff1db 100%);
    opacity: 0.7;
    filter: blur(46px);
    transform: translate3d(0, 0, 0); // 解决 safari 上 filter: blur() 异常问题，以强制浏览器对该特定元素使用GPU加速
  }

  .bannerTitle {
    // width: 124px;
    height: 42px;
    line-height: 42px;
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #404040;
  }

  .bannerTitleEn {
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    letter-spacing: 1px;
  }

  .headBg {
    position: relative;
    z-index: 9;
    width: 100%;
    height: 334px;
    margin-top: 29px;
    background: no-repeat
      url("../../../assets/img/aboutus/mobile/banner/banner-bg.png");
    background-size: 100%;
  }

  .bannerContentBox {
    padding: 0 20px;
  }

  .bannerContentInfo {
    position: relative;
    z-index: 10;
    box-sizing: border-box;
    // width: 335px;
    // height: 534px;
    margin: -128px auto 0;
    padding: 31px 16px 30px;
    background: linear-gradient(312deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset -1px -1px 0px 0px #ffffff;
    border-radius: 6px;
    text-align: left;
  }

  .contentItem {
    margin-bottom: 16px;
    line-height: 26px;
    font-size: 14px;
    font-weight: 300;
    color: #404040;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
